import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { filter, Observable, Subject, take, takeUntil } from 'rxjs';

import { CommercialInvitation, Invitation, InvitationStatusType } from '@vi-iot/client';

import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { FormatPhoneNumberPipe, NO_VALUE } from '@pipes';
import { AuthStore, InvitationsStore } from '@store';
import { ViCardComponent } from '@vi-iot/ui/index';
import { AdditionalServicesComponent } from 'src/app/+booking/booking-plans/additional-services/additional-services.component';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';
import { RemainingPipe } from '../../pipes/remaining.pipe';

@Component({
  selector: 'app-commercial-invitation',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    ViCardComponent,
    FormatPhoneNumberPipe,
    RemainingPipe,
    RouterLink,
    MatIconModule,
  ],
  templateUrl: './commercial-invitation.component.html',
  styleUrls: ['./commercial-invitation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialInvitationComponent implements OnInit, OnDestroy {
  @Input() invitation: Invitation;
  @Input() owner: CommercialInvitation;

  readonly NO_VALUE = NO_VALUE;

  InvitationStatusType = InvitationStatusType;
  invitationStatus$: Observable<InvitationStatusType>;
  private dialogConfig = new MatDialogConfig();
  private isGermanUser: boolean;
  private ngUnsubscribe$ = new Subject<void>();
  constructor(
    private invitationsStore: InvitationsStore,
    private dialog: MatDialog,
    private authStore: AuthStore
  ) {}

  ngOnInit(): void {
    this.invitationStatus$ = this.invitationsStore.getCommercialInvitationStatus(
      this.invitation.token
    );
    this.authStore.isCompanyFromGermany$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isCompanyFromGermany) => {
        this.isGermanUser = isCompanyFromGermany;
      });
  }

  confirmInvitation(): void {
    this.invitationsStore.updateCommercialInvitation(
      this.invitation.token,
      InvitationStatusType.Accepted,
      this.owner ? `${this.owner.firstName} ${this.owner.lastName}` : ''
    );

    this.invitationsStore
      .getCommercialInvitationStatus(this.invitation.token)
      .pipe(
        filter((status) => status === InvitationStatusType.Accepted),
        take(1),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((accepted) => {
        if (accepted && this.isGermanUser) {
          this.dialogConfig.maxHeight = '90vh';
          this.dialogConfig.data = {
            popupTitle: '+ADDITIONAL.SERVICE.FEATURE.SUCCESSFULLY_CONFIRM_SERVICE',
          };
          this.dialog.open(AdditionalServicesComponent, this.dialogConfig);
        }
      });
  }

  declineInvitation(): void {
    this.invitationsStore.updateCommercialInvitation(
      this.invitation.token,
      InvitationStatusType.Rejected,
      this.owner ? `${this.owner.firstName} ${this.owner.lastName}` : ''
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
